import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import HomePage from './components/HomePage/HomePage';
import DetectionPage from './components/Detection/DetectionPage';
import LoginPage from './components/Login/LoginPage';
import SignupPage from './components/Signup/SignupPage';
import HistoryPage from './components/History/HistoryPage'; // Import HistoryPage
import About from './components/About/About';
import { AuthProvider } from './context/AuthContext'; // Import AuthProvider
import Footer from './components/Footer/Footer';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import './App.css'; // Basic styling

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Navbar />
          <main className="container">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/detection" element={<DetectionPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;